import styled from 'styled-components';

import { Breakpoint, Color, DirectionEnum, FontWeight, ZIndex } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { hexToRgba } from '../../utils';
import { Icon } from '../icon/icon.component';

import { ArrowButtonProps, DotProps, QuoteProps, StyledIconProps } from './quoteCarousel.types';

export const Container: StyledComponent<'div'> = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 568px;
  position: relative;
  max-width: 1000px;
  overflow: hidden;

  @media ${Breakpoint.Tablet} {
    max-width: 960px;
  }

  @media ${Breakpoint.Mobile} {
    max-width: 728px;
  }

  @media ${Breakpoint.SmallMobile} {
    min-height: 352px;
  }
`;

export const Content: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const ContainerInsideSlider: StyledComponent<'div'> = styled.div`
  max-width: 1000px;
  width: 100%;
  position: relative;
  height: 100%;
`;

export const TextContent: StyledComponent<'div'> = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 32px;
  width: calc(100% - 150px);
  max-width: 740px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);

  @media ${Breakpoint.Tablet} {
    width: calc(100% - 220px);
  }

  @media ${Breakpoint.SmallMobile} {
    width: calc(100% - 40px);
  }
`;

export const QuoteText: StyledComponent<'div', QuoteProps> = styled.div<QuoteProps>`
  font-size: ${({ $hasSmallerFont }: QuoteProps) => $hasSmallerFont ? '40px' : '60px'};
  line-height: ${({ $hasSmallerFont }: QuoteProps) => $hasSmallerFont ? '44px' : '64px'};
  font-weight: ${FontWeight.Medium};
  letter-spacing: -0.01em;
  margin-bottom: 32px;

  @media ${Breakpoint.Mobile} {
    font-size: 40px;
    line-height: 44px;
  }

  @media ${Breakpoint.SmallMobile} {
    font-size: 30px;
    line-height: 38px;
  }
`;

export const Author: StyledComponent<'p'> = styled.p`
  font-size: 22px;
  line-height: 28px;
  letter-spacing: -0.01em;
  font-weight: ${FontWeight.Medium};
  margin-bottom: 4px;

  @media ${Breakpoint.Tablet} {
    line-height: 30px;
  }

  @media ${Breakpoint.SmallMobile} {
    font-size: 16px;
    line-height: 22px;
  }
`;

export const AuthorSpecialty: StyledComponent<'p'> = styled.p`
  font-size: 16px;
  line-height: 22px;
  font-weight: ${FontWeight.Light};

  @media ${Breakpoint.SmallMobile} {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const ArrowButton: StyledComponent<'button', ArrowButtonProps> = styled.button.attrs<ArrowButtonProps>({ type: 'button' })`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: ${Color.Black};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${({ $position }: ArrowButtonProps): string => $position === DirectionEnum.Left ? 'left: 0' : 'right: 0'};
  z-index: ${ZIndex.QuoteCarouselArrows};

  @media ${Breakpoint.SmallMobile} {
    display: none;
  }
`;

export const DotsContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const SwiperContainer: StyledComponent<'div'> = styled.div`
  width: 100%;
  position: relative;
  height: 100%;
`;

export const StyledIcon: StyledComponent<typeof Icon, StyledIconProps> = styled(Icon)<StyledIconProps>`
  ${({ $position }: StyledIconProps): string => $position === DirectionEnum.Left ? 'margin-right: 3px' : 'margin-left: 3px'};
`;

export const Dot: StyledComponent<'button', DotProps> = styled.button.attrs<DotProps>({ type: 'button' })`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  transition: 0.2s;
  flex-shrink: 0;
  background-color: ${({ $isActive }: DotProps): string => $isActive ? Color.Black : hexToRgba(Color.Black, 0.2)};

  & + & {
    margin-left: 16px;
  }
`;

export const CircleBackgroundItem: StyledComponent<'img'> = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: ${ZIndex.Min};
  height: 565px;

  @media ${Breakpoint.SmallMobile} {
    height: 350px;
  }
`;
